module.exports = __webpack_public_path__ + "media/images/athletes/2209-fc8ebdbf2086859443618a300643c4b7.png";